var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSub05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 9.07129C23.3811 9.07129 17.3824 11.9932 12.5687 15.4612C7.7376 18.9419 3.91298 23.1068 1.59767 25.9051L1.57834 25.9288C0.544393 27.2154 0 28.8457 0 30.5001C0 32.1544 0.544393 33.7849 1.57834 35.0714L1.59767 35.0951C3.91298 37.8934 7.7376 42.0583 12.5687 45.5389C17.3824 49.0069 23.3811 51.9289 30 51.9289C36.6189 51.9289 42.6176 49.0069 47.4313 45.5389C52.2626 42.0583 56.0871 37.8934 58.4023 35.0951L58.4216 35.0714C59.4557 33.7849 60 32.1544 60 30.5001C60 28.8457 59.4557 27.2154 58.4216 25.9288L58.4023 25.9051C56.0871 23.1068 52.2626 18.9419 47.4313 15.4612C42.6176 11.9932 36.6189 9.07129 30 9.07129Z",
    fill: "#FFCACF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0003 40.1431C35.3259 40.1431 39.6431 35.8259 39.6431 30.5003C39.6431 25.1747 35.3259 20.8574 30.0003 20.8574C24.6747 20.8574 20.3574 25.1747 20.3574 30.5003C20.3574 35.8259 24.6747 40.1431 30.0003 40.1431Z",
    fill: "#F84343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSub05);
export default __webpack_public_path__ + "static/media/sub_05.a19fe6cded670d83d39da0dd206b652a.svg";
export { ForwardRef as ReactComponent };